/// <amd-module name="VSSUI/Components/Calendar/Calendar" />

import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { FocusTrapZone } from "OfficeFabric/FocusTrapZone";
import { Calendar as OFCalendar, ICalendarProps as IOFCalendarProps } from "OfficeFabric/Calendar";
/** @deprecated */
export class Calendar extends React.Component<IOFCalendarProps> {
    constructor(props: IOFCalendarProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <FocusTrapZone isClickableOutsideFocusTrap={true}>
                <OFCalendar {...this.props} />
            </FocusTrapZone>
        );
    }
}

VssComponent.register("fabric.pickers.calendar", Calendar);
